import { Config } from '@/core/config/config';
import { productService } from '@/projects/platform/services/product-service';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';

import { Button, FileUploader, LoadPanel } from 'devextreme-react';
import { DataGridTypes } from 'devextreme-react/data-grid';
import { t } from 'i18next';
import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';

const uploadUrl = `${Config.VITE_APP_GATEWAY_URL}/api/product/product/upload-products`


const UploadProducts = () => {
    const fileUploaderRef = useRef<FileUploader>(null);
    const [columns, setColumns] = useState<any>();
    const [uploadedData, setUploadedData] = useState<any>();
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [allDisabled, setAllDisabled] = useState<any>(false);
    const navigate = useNavigate();
    const goToProducts = async () => {
        navigate(`/product-list`)
    }

    const [requestsStore] = useState(() => createCustomStore({
        key: ['id'],
        load: productService.getProductUploadRequests,
        byKey: (key, loadOptions) => {
            if (key) {
                loadOptions.filter = ["id", "=", key];
            }
        },
    }));

    const onBeforeSend = async (e: any) => {

        setLoadPanelVisible(true);
        e.request.setRequestHeader("Authorization", 'Bearer ' + localStorage.getItem(Config.VITE_APP_ACCESS_TOKEN_KEY as string))
    }

    const onUploaded = async (e: any) => {
        var response = JSON.parse(e.request.response);
        if (response.data) {
            setUploadedData(response.data);
            setColumns(Object.keys(response.data));
        }
        setLoadPanelVisible(false);
    }

    const onUploadError = async (e: any) => {
        console.log(e.error);
        setUploadedData([]);
        setColumns([]);
        setLoadPanelVisible(false);
    }


    const position = { of: '#panel' };
    const allowedPageSizes: (DataGridTypes.PagerPageSize | number)[] = [10, 20, 50, 100, 200];

    return (
        <>
            <div id="panel">
                {/* <SingleCard title={t("import_products")}> */}

                <div className="row justify-content-center">
                    <div className='col-auto mt-3 '>
                        <Button
                            text={t('back')}
                            type='normal'
                            icon='back'
                            onClick={goToProducts}
                        />
                    </div>

                    <div className='col-auto mb-2'>

                        <FileUploader
                            ref={fileUploaderRef}
                            width={150}
                            selectButtonText={t("select_file")}
                            uploadButtonText={t("upload")}
                            showFileList={false}

                            labelText=""
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            uploadMode="instantly"
                            uploadUrl={uploadUrl}
                            onBeforeSend={onBeforeSend}
                            onUploaded={onUploaded}
                            onUploadError={onUploadError}
                            disabled={allDisabled}
                        />
                        <a href='/Product_Example.xlsx'><i style={{ "fontSize": "14px" }} className='dx-icon dx-icon-download'></i>Excel Template</a>
                    </div>

                </div >


                <DataGridWrapper
                datasource={requestsStore}
                remoteOperations={false}
                pagerVisible={true}
                filterVisible={true}
                editingConfig={{}}
                columns={[
                    {
                        dataField: 'requestType',
                        caption: t('request'),
                        allowFiltering: true,
                    },
                    {
                        dataField: 'requestDate',
                        caption: t('request_date'),
                        allowFiltering: false,
                        dataType: 'datetime',
                        format: 'dd.MM.yyyy HH:mm',
                    },
                    {
                        dataField: 'requestStatus',
                        caption: t('status'),
                        allowFiltering: false,
                    }
                ]}
            />


            </div >
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={position}
                visible={loadPanelVisible}
                showIndicator={true}
                shading={false}
                showPane={true}
                activeStateEnabled={false}
            />
        </>

    )
}
export default UploadProducts